import { render, staticRenderFns } from "./Pools.vue?vue&type=template&id=40bcd1f7&scoped=true&"
import script from "./Pools.vue?vue&type=script&lang=js&"
export * from "./Pools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcd1f7",
  null
  
)

export default component.exports